import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-general-template',
  templateUrl: './general-template.component.html',
  styleUrls: ['./general-template.component.css']
})
export class GeneralTemplateComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
